import { Component, OnInit, EventEmitter, Output, Input } from "@angular/core";
@Component({
    selector: "dodo-request-callback-dialog-layout",
    templateUrl: "./request-callback-dialog-layout.html",
    styleUrls: ["./request-callback-dialog-layout.scss"],
    standalone: false
})
export class RequestCallbackDialogLayoutComponent implements OnInit {
	@Input() source = "";
	@Output() close = new EventEmitter();
	constructor() {}
	ngOnInit() {}
}
